var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 19.3906C6.36458 19.3906 5.78906 19.2005 5.39844 18.8203C5.01302 18.4401 4.82031 17.8698 4.82031 17.1094V8.13281C4.82031 7.3724 5.01302 6.80208 5.39844 6.42188C5.78906 6.04167 6.36458 5.85156 7.125 5.85156H16.2109L15.25 6.80469H7.14062C6.70312 6.80469 6.36719 6.92188 6.13281 7.15625C5.89844 7.39062 5.78125 7.73177 5.78125 8.17969V17.0625C5.78125 17.5156 5.89844 17.8568 6.13281 18.0859C6.36719 18.3203 6.70312 18.4375 7.14062 18.4375H16.2031C16.5625 18.4375 16.8516 18.3203 17.0703 18.0859C17.2943 17.8568 17.4062 17.5156 17.4062 17.0625V9.00781L18.3672 8.04688V17.1094C18.3672 17.8698 18.1797 18.4401 17.8047 18.8203C17.4349 19.2005 16.9062 19.3906 16.2188 19.3906H7.125ZM10.1797 14.2188C10.1224 14.2448 10.0677 14.2318 10.0156 14.1797C9.96875 14.1276 9.95833 14.0755 9.98438 14.0234L10.625 12.7266L17.8984 5.44531L18.8047 6.33594L11.5156 13.6172L10.1797 14.2188ZM19.3281 5.82031L18.4219 4.91406L18.9297 4.40625C19.0547 4.29167 19.1901 4.22917 19.3359 4.21875C19.4818 4.20833 19.6094 4.25781 19.7188 4.36719L19.8438 4.49219C19.9635 4.61719 20.0208 4.7526 20.0156 4.89844C20.0156 5.03906 19.9557 5.17448 19.8359 5.30469L19.3281 5.82031Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2677bfe4.svg";
export { ForwardRef as ReactComponent };